var fetchWithAuth = require('./fetchWithAuth.jsx').fetchWithAuth;

var defaultFetchOptions = function () {
    return {
        retryOn: [503],
        credentials: 'same-origin',
        headers: {
            'pragma': 'no-cache',
            'cache-control': 'no-cache',
            'Content-Type': 'application/json'
        }
    };
}

var userInfo = {
    memberJoinProductType: '',
    memberJoinRateType: '',
    memberJoinState: '',
    memberJoinDistrict: '',
    memberJoinYearsInPractice: -1,
    isMember: false
};

var setUserInfo = function (property, value) {
    userInfo[property] = value;
};

// ASAWEB-864 helpers.
// isDefined: every required URL component is present (not undefined/null/'').
//   A builder returns '' when this fails, so the request is skipped instead of
//   firing a URL that contains the literal string "undefined".
// qv: coerce an OPTIONAL query value, mapping undefined/null to '' so the URL
//   never carries "undefined" while still allowing a legitimately empty param.
var isDefined = function () {
    for (var i = 0; i < arguments.length; i++) {
        var v = arguments[i];
        if (v === undefined || v === null || v === '') return false;
    }
    return true;
};
var qv = function (value) {
    return (value === undefined || value === null) ? '' : value;
};

var getData = function (dataKey) {
    var fullUrl = getRequestUrl[dataKey] ? getRequestUrl[dataKey]() : null;
    return getDataWithUrl(fullUrl);
}

var getDataWithUrl = function (url) {
    return new Promise(function (resolve, reject) {
        if (url) {
            fetchWithAuth(url, defaultFetchOptions())
                .then((result) => {
                    resolve(result.json());
                }, (error) => {
                    reject(error);
                });
        } else {
            // ASAWEB-864: a URL builder returned '' because a required component
            // was undefined/null/''. Reject so the caller stops its spinner
            // instead of hanging on a promise that never settles.
            reject(new Error('Request skipped: a required URL parameter was missing.'));
        }
    }.bind(this));
}

var postData = function (url, apiReadyData) {
    // ASAWEB-864: never POST to an empty/undefined URL — a builder that returned
    // '' signals a required component was missing. Reject so callers recover.
    if (!url) {
        return Promise.reject(new Error('Request skipped: a required URL parameter was missing.'));
    }

    var options = {
        credentials: 'same-origin',
        method: 'POST',
        headers: {
            'pragma': 'no-cache',
            'cache-control': 'no-cache',
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
            'Accept': 'application/json'
        },
        body: JSON.stringify({
            json: JSON.stringify(apiReadyData)
        })
    };

    return new Promise(function (resolve, reject) {
        fetchWithAuth(url, options)
            .then((result) => {
                if (result.ok) {
                    return result.json().then(resolve);
                } else {
                    return result.json()
                        .then(errorData => reject({ ...errorData, status: result.status, statusText: result.statusText }))
                        .catch(() => reject({ status: result.status, statusText: result.statusText }));
                }
            })
            .catch(reject);
    });
}

var imitateFormSubmit = function (url, data) {
    var form = $('<form></form>');

    form.attr('method', 'post');
    form.attr('action', url);

    for (var prop in data) {
        var field = $('<input></input>');

        field.attr('type', 'hidden');
        field.attr('name', prop);
        field.attr('value', data[prop]);

        form.append(field);
    }

    $(document.body).append(form);
    form.submit();
}

var accountPanelApiDropdownData = {
    name: ['prefix', 'suffix', 'credentials'],
    clinicalInterests: ['clinicalInterests'],
    education: ['institutions', 'educationProgramType', 'fellowshipType', 'fellowshipSubType', 'countriesAndStates'],
    otherProCerts: ['activeSubboards'],
    contactInfo: ['countriesAndStates'],
    medicalLicensure: ['countriesAndStates']
};

var getApiResponseKey = {
    'demographics': 'Demographics',
    'medicalLicensure': 'MedicalLicensures',
    'clinicalInterests': 'ClinicalInterest',
    'contactInfo': 'AddressInfomations',
    'education': 'CustomerEducationInfo',
    'phone': '_Customerphones',
    'committees': 'CommitteeMemberInfoCompleteDetails',
    'name': 'CustomerInformation',
    'otherProCerts': '_Certifications',
    'email': '_CustomerEmails',
    'password': '_CustomerEmails',
    'articleLinks': 'Articles',
    'memberJoinPricingInfo': 'MemberJoinPricingInfo',
    'reports': 'CustomerRelationshipInformation'
}

var uniqueId = {
    'medicalLicensure': 'CustomRecordId',
    'clinicalInterests': 'CusDemographicId',
    'contactInfo': 'AddressId',
    'education': 'CustomerEducationId',
    'phone': 'CustomRecordId',
    'committees': 'LicenseId',
    'otherProCerts': 'CustomRecordId',
    'name': 'CustomerId',
    'email': 'CustomRecordId',
    'articleLinks': 'ArticleId',
    'reports': 'CustomerRelationshipId',
    'password': 'CustomRecordId'
}

var postUrl = {
    'demographics': '/api/account/updateprimarydemographics',
    'education': '/api/account/updateeducation',
    'medicalLicensure': '/api/account/updatecustomerlicenses',
    'phone': '/api/account/updatecustomerphone',
    'contactInfo': '/api/account/updatecustomeraddress',
    'otherProCerts': '/api/account/updateotherprocerts',
    'email': '/api/account/updatecustomeremail',
    'clinicalInterests': '/api/account/updateclinicalinterests',
    'primaryPracticeLocation': '/api/account/updateprimarypracticelocation',
    'primaryDistrictLocation': '/api/account/updateprimarypracticelocation',
    'handlePasswordReset': () => "/api/password/HandlePasswordReset",
    'name': '/api/account/updatepersonalinfo',
    'articleLinks': '/api/account/createupdatearticlelinks',
    'password': '/api/account/updatepassword',
    'reports': '/api/account/getstaterosterreport',
    'npiNumber': '/api/account/UpdateCustomerBasicInfo',
    'directoryProfile': '/api/account/updatesolicitationpreferences',
    'emailPreferences': '/api/account/updateemailpreferences',
    'solicitations': '/api/account/updatesolicitationpreferences'
}

var memberJoinPostUrl = {
    'createAccount': () => "/api/reactforms/CreateAccountFromMemberJoin",
    'demographics': () => '/api/account/updateprimarydemographics',
    'education': () => '/api/account/UpdateEducationHandleCustomInstitution',
    'medicalLicensure': () => '/api/account/UpdateCustomerLicensesListInput',
    'phone': () => '/api/account/updatecustomerphone',
    'contactInfo': () => '/api/account/UpdateMemberJoinCustomerAddress',
    'otherProCerts': () => '/api/account/UpdateMultipleProCerts',
    'email': () => '/api/account/updatecustomeremail',
    'clinicalInterests': () => '/api/account/updateclinicalinterests',
    primaryPracticeLocation: () => '/api/account/updateprimarypracticelocation',
    primaryDistrictLocation: () => '/api/account/updateprimarypracticelocation',
    'customerBasicInfo': () => '/api/account/UpdateCustomerBasicInfo',
    nameInfo: () => '/api/account/updatepersonalinfo',
    militaryBranch: () => '/api/account/UpdateMilitaryBranch',
    governmentSector: () => '/api/account/UpdateGovernmentSector',
    applicationInfo: () => '/api/reactforms/SubmitMemberJoinApplicationInfo',
    paymentInformation: () => '/api/reactforms/SubmitMemberJoinPayment',
    checkIfEmailExists: () => '/api/reactforms/CheckIfEmailExists',
    orderNumber: (number) => isDefined(number) ? '/api/reactforms/setsessionordernumber?orderNumber=' + number : ''
}

var memberJoinDeleteUrl = {
    'phone': () => '/api/account/deletecustomerphone',
    'medicalLicensure': () => '/api/account/deletecustomerlicenses',
    'education': () => '/api/account/deletecustomereducation',
    'otherProCerts': () => '/api/account/DeleteMultipleCustomerCertification',
    'articleLinks': () => '/api/account/deletearticlelink',
    militaryBranch: () => '/api/account/DeleteMilitaryBranch',
    governmentSector: () => '/api/account/DeleteGovernmentSector'
}

var shopUrl = {
    'addToCart': '/api/Altai/AddToCart'
}

var deleteUrl = {
    'accountNotification': () => '/api/reactForms/DeleteAccountNotification',
    'phone': '/api/account/deletecustomerphone',
    'medicalLicensure': '/api/account/deletecustomerlicenses',
    'education': '/api/account/deletecustomereducation',
    'otherProCerts': '/api/account/deletecustomercertification',
    // no clinicalInterests entry: updateclinicalinterests replaces the whole set, so removals go
    // through the post and there is no working delete endpoint to call.
    'articleLinks': '/api/account/deletearticlelink',
    'contactInfo': '/api/account/markaddressasbad',
    'email': '/api/account/deletecustomeremail'
}

var getRequestUrl = {
    accountNotifications: () => '/api/reactForms/GetAccountNotifications',
    createAccount: () => "/api/account/createAccount",
    membershipSummary: () => "/api/account/getmembershipsummary",
    otherProCerts: () => "/api/account/getotherprocerts",
    name: () => "/api/account/getcustomerinfo",
    society: () => "/api/account/getcomponentsociety",
    demographics: () => "/api/account/getprimarydemographics",
    medicalLicensure: () => "/api/account/getcustomerlicenses",
    clinicalInterests: () => "/api/account/getclinicalinterests",
    customerNpiNumber: () => '/api/account/GetCustomerNpiNumber',
    contactInfo: () => "/api/account/getcustomeraddress",
    memberJoinContactInfo: () => '/api/reactforms/GetMemberJoinCustomerAddress',
    phone: () => "/api/account/getcustomerphone",
    committees: () => "/api/account/getcustomercommittees",
    email: () => "/api/account/getcustomeremail",
    password: () => "/api/account/getcustomeremail",
    education: () => "/api/account/geteducation",
    articleLinks: () => "/api/account/getarticlelinks",
    // productType + rateType are required to price; state + district are optional
    // (empty for members without a component), so coerce them rather than block.
    memberJoinPricingInfo: () => isDefined(userInfo.memberJoinProductType, userInfo.memberJoinRateType)
                                                ? "/api/reactforms/GetMemberJoinPricing?productType="
                                                + userInfo.memberJoinProductType
                                                + '&rateType=' + userInfo.memberJoinRateType
                                                + '&stateAbbreviation=' + qv(userInfo.memberJoinState)
                                                + '&districtCode=' + qv(userInfo.memberJoinDistrict)
                                                : '',
    countriesAndStates: () => "/api/account/GetCountriesAndStates",
    requestPasswordReset: () => userInfo.emailAddress && userInfo.forgotPasswordPageId ? "/api/password/RequestPasswordReset?emailaddress=" + userInfo.emailAddress + '&forgotPasswordPageId=' + userInfo.forgotPasswordPageId + '&g-recaptcha-response=' + qv(userInfo.reCAPTCHAResponse) : '',
    canResetPassword: () => userInfo.id && userInfo.secret ? "/api/password/CanResetPassword?id=" + userInfo.id + "&secret=" + userInfo.secret : '',
    countries: () => "/api/account/GetCountries",

    militaryBranch: () => "/api/account/GetUserMilitaryBranch",
    governmentSector: () => "/api/account/GetUserGovernmentSector",
    customerInfo: () => "/api/account/getcustomerinfo",
    modalMessages: () => "/api/account/getMessage",
    reports: () => "/api/account/GetStateComponentReports",

    directoryProfile: () => '/api/account/getcustomersolicitationpreference',
    emailPreferences: () => '/api/account/getcustomeremailpreferences',
    solicitations: () => '/api/account/getcustomersolicitationpreference',

    race: () => '/api/account/getactiveracetypes',
    ethnicity: () => '/api/account/getactiveethnicitytypes',

    checkIfUserExists: (firstName, lastName) => isDefined(firstName, lastName) ? "/api/reactforms/CheckIfUserExists?firstName=" + firstName + "&lastName=" + lastName : '',
    shoppingCartCount: () => '/api/reactForms/GetShoppingCartCount',
    gender: () =>'/api/account/getactivegendercodes',

    districts: () => "/api/account/GetAllMembershipJoinDistrictInformation",
    primaryPracticeLocations: () => "/api/account/GetPrimaryPracticeLocations"
}

var counter = 0;
var getNextId = () => {
    counter++;
    return counter;
};

module.exports = {
    accountPanelApiDropdownData: accountPanelApiDropdownData,
    imitateFormSubmit: imitateFormSubmit,
    userInfo: userInfo,
    getData: getData,
    getDataWithUrl: getDataWithUrl,
    postData: postData,
    getApiResponseKey: getApiResponseKey,
    getNextId: getNextId,
    getRequestUrl: getRequestUrl,
    uniqueId: uniqueId,
    memberJoinPostUrl: memberJoinPostUrl,
    memberJoinDeleteUrl: memberJoinDeleteUrl,
    postUrl: postUrl,
    deleteUrl: deleteUrl,
    setUserInfo: setUserInfo,
    defaultFetchOptions: defaultFetchOptions,
    shopUrl: shopUrl
};
